module.exports = __webpack_public_path__ + "img/sec_car2.5082d38f.jpg";